// extracted by mini-css-extract-plugin
export default {"loadingLogo":"LoadingLogo-module_loadingLogo__U210o"};